module.exports = __webpack_public_path__ + "static/img/banklist.eda2f865.png";